import React from 'react';
import Modal from './Modal';

const MissionModal = ({ isOpen, onClose, children, title = 'Create Mission', onPreviewToggle, onReset }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="modal-header">
        <h3>{title}</h3>
        <button className="close-btn" onClick={onClose}>×</button>
      </div>
      <div className="modal-body">
        {children}
      </div>
      <div className="modal-footer">
        <div className="d-flex justify-content-end align-items-center">
          <button
            type="button"
            className="btn btn-outline-info me-2"
            onClick={onPreviewToggle}
          >
            Preview
          </button>
          <button type="button" className="btn btn-outline-secondary me-2" onClick={onReset}>
            Reset Form
          </button>
          <button type="submit" className="btn btn-primary" form="mission-form">
            Save Mission
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default MissionModal; 